import brandColors from "../brandColors";

export const ROUTE_COLORS = [
  "#2563EB", "#DC2626", "#9333EA", "#EA580C", "#0D9488",
  "#DB2777", "#4338CA", "#65A30D", "#0891B2", "#B45309",
];

export function colorForIndex(index) {
  return ROUTE_COLORS[index % ROUTE_COLORS.length];
}

export const UNASSIGNED_COLOR = "#9CA3AF";
export const OUTLET_COLOR = brandColors.PRIMARY;
export const ENDPOINT_COLOR = "#1C1E1B";
